type WrapperGeneralProps = {
	children: React.ReactNode;
	className?: string;
};

export default function WrapperGeneral({ className = "", children }: WrapperGeneralProps) {
	return <div className={`wrapper-general ${className}`}>{children}</div>;
}
